import { z } from 'zod/v4';
import { distributionDataResponseSchema } from './distribution';
import { heatMapTimeSeriesDataResponseSchema } from './heatmap';
import { singleValueDataResponseSchema, singleValueTimeSeriesDataResponseSchema } from './single-value';
import { tabularDataResponseSchema } from './tabular';
import { timeSeriesDataResponseSchema } from './time-series';

/**
 * Combined schema for all DataResponse types.
 */
export const dataResponseSchema = z.discriminatedUnion('type', [
  timeSeriesDataResponseSchema,
  singleValueDataResponseSchema,
  singleValueTimeSeriesDataResponseSchema,
  heatMapTimeSeriesDataResponseSchema,
  tabularDataResponseSchema,
  distributionDataResponseSchema,
]);

export type DataResponseSchema = z.infer<typeof dataResponseSchema>;
